import { render, staticRenderFns } from "./NavigationPanel.vue?vue&type=template&id=2a0654d8"
import script from "./NavigationPanel.vue?vue&type=script&lang=js"
export * from "./NavigationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports